(() => {
  const STORAGE_KEY = 'flippo_quiz_referral';
  const COOKIE_KEY = 'flippo_quiz_referral';
  const configElement = document.getElementById('FlippoReferralConfig');
  let rawConfig = [];
  let memoryPayload = null;
  let blackweek = {};
  try {
    blackweek = JSON.parse(document.getElementById('FlippoBlackweekConfig')?.textContent || '{}');
  } catch (_) {}
  const blackweekEnabled = blackweek.enabled === true && Date.parse(blackweek.endsAt) > Date.now();

  try {
    rawConfig = configElement ? JSON.parse(configElement.textContent || '[]') : [];
  } catch (error) {
    rawConfig = [];
  }

  const normalize = (value) => String(value == null ? '' : value).trim();
  const normalizeCode = (value) => normalize(value).toLocaleUpperCase('es');
  const normalizePlanId = (value) => {
    const raw = normalize(value);
    if (!raw) return '';
    return raw.includes('/') ? raw.split('/').filter(Boolean).pop() : raw;
  };
  const normalizeImage = (image) => {
    if (!image || typeof image !== 'object') return null;
    const src = normalize(image.src);
    if (!src) return null;
    return {
      src,
      srcset: normalize(image.srcset),
      alt: normalize(image.alt)
    };
  };

  const normalizeConfig = (config, index) => {
    const rawDiscountPercent = Number(config.discountPercent);

    return {
      id: normalize(config.id) || `referral-${index + 1}`,
      enabled: config.enabled === true && !(normalizeCode(config.value) === 'BLACKFRIDAY'),
      isBlackweek: config.isBlackweek === true,
      mgm: config.mgm === true,
      parameter: normalize(config.parameter) || 'ref',
      value: normalize(config.value),
      sellingPlanId: normalizePlanId(config.sellingPlanId),
      applyPlan: config.applyPlan == null
        ? config.applyPlanPricing !== false
        : config.applyPlan !== false,
      applyPricing: config.applyPricing == null
        ? config.applyPlanPricing !== false
        : config.applyPricing !== false,
      discountPercent: Number.isFinite(rawDiscountPercent)
        ? Math.max(0, Math.min(100, rawDiscountPercent))
        : null,
      discountText: normalize(config.discountText),
      matchPlanQuantity: config.matchPlanQuantity !== false,
      image: normalizeImage(config.image),
      storageDays: Math.max(1, Math.min(90, Number(config.storageDays) || 30))
    };
  };

  const configList = (Array.isArray(rawConfig) ? rawConfig : [rawConfig])
    .filter((config) => config && typeof config === 'object')
    .map(normalizeConfig);
  if (blackweekEnabled) {
    const campaign = normalizeConfig({
      id: 'blackweek', value: 'blackfriday', parameter: 'promo', enabled: true,
      sellingPlanId: blackweek.sellingPlanId, applyPlan: true, applyPricing: true,
      discountPercent: 30, discountText: blackweek.discountText,
      matchPlanQuantity: false, storageDays: 30, isBlackweek: true
    }, configList.length);
    campaign.enabled = true;
    configList.unshift(campaign);
  }

  const clearStoredReferral = () => {
    memoryPayload = null;
    try {
      window.localStorage.removeItem(STORAGE_KEY);
    } catch (error) {
      // Storage can be unavailable in strict privacy modes.
    }
    document.cookie = COOKIE_KEY + '=; Max-Age=0; Path=/; SameSite=Lax';
  };

  const writeReferralCookie = (payload) => {
    const maxAge = Math.max(0, Math.floor((Number(payload.expiresAt) - Date.now()) / 1000));
    const secure = window.location.protocol === 'https:' ? '; Secure' : '';
    document.cookie = COOKIE_KEY + '=' + encodeURIComponent(JSON.stringify(payload)) +
      '; Max-Age=' + maxAge + '; Path=/; SameSite=Lax' + secure;
  };

  const readReferralCookie = () => {
    const prefix = COOKIE_KEY + '=';
    const cookie = String(document.cookie || '').split('; ').find(function (item) {
      return item.startsWith(prefix);
    });
    if (!cookie) return null;

    try {
      return JSON.parse(decodeURIComponent(cookie.slice(prefix.length)));
    } catch (error) {
      return null;
    }
  };

  const notifyReferralChange = () => {
    window.dispatchEvent(new CustomEvent('flippo:referral:change'));
  };

  const persistReferral = (payload) => {
    memoryPayload = payload;
    writeReferralCookie(payload);

    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
    } catch (error) {
      // The cookie and in-memory value remain available.
    }
    return payload;
  };

  const storeReferral = (config, options = {}) => {
    const attributionCode = normalize(options.attributionCode);
    const payload = {
      id: config.id,
      code: config.value,
      attributionCode,
      validationStatus: options.requiresValidation ? 'pending' : 'not_required',
      expiresAt: Date.now() + (config.storageDays * 24 * 60 * 60 * 1000)
    };
    return persistReferral(payload);
  };

  const findPayloadConfig = (payload) => {
    if (!payload) return null;

    const enabledConfigs = configList.filter((config) => config.enabled && (config.value || config.mgm));
    const payloadId = normalize(payload.id);
    if (payloadId) {
      const idMatch = enabledConfigs.find((config) => config.id === payloadId);
      if (
        idMatch &&
        (!payload.code || normalizeCode(idMatch.value) === normalizeCode(payload.code))
      ) {
        return idMatch;
      }
    }

    if (!payload.code) return null;
    return enabledConfigs.find((config) => (
      normalizeCode(config.value) === normalizeCode(payload.code)
    )) || null;
  };

  const readStoredReferral = () => {
    const candidates = [];

    try {
      candidates.push(JSON.parse(window.localStorage.getItem(STORAGE_KEY) || 'null'));
    } catch (error) {
      // Storage can contain malformed or legacy data.
    }
    candidates.push(readReferralCookie(), memoryPayload);

    for (const payload of candidates) {
      const config = findPayloadConfig(payload);
      if (
        config &&
        Number.isFinite(Number(payload.expiresAt)) &&
        Number(payload.expiresAt) > Date.now()
      ) {
        memoryPayload = payload;
        return { config, payload };
      }
    }

    clearStoredReferral();
    return null;
  };

  const captureReferral = () => {
    if (blackweekEnabled) {
      const config = configList[0];
      const payload = storeReferral(config);
      return { config, payload };
    }
    const url = new URL(window.location.href);
    const enabledConfigs = configList.filter((config) => config.enabled && (config.value || config.mgm));
    const configuredParameters = new Set(configList.map((config) => config.parameter));
    const hasReferralParameter = Array.from(configuredParameters).some((parameter) => (
      url.searchParams.has(parameter)
    ));

    if (!hasReferralParameter) return readStoredReferral();

    const matchedConfig = enabledConfigs.find((config) => config.value && (
      url.searchParams.has(config.parameter) &&
      normalizeCode(url.searchParams.get(config.parameter)) === normalizeCode(config.value)
    ));

    if (matchedConfig) {
      const separateAttributionCode =
        matchedConfig.mgm && matchedConfig.parameter !== 'ref'
          ? normalize(url.searchParams.get('ref'))
          : '';
      const payload = storeReferral(matchedConfig, {
        attributionCode: separateAttributionCode,
        requiresValidation: Boolean(separateAttributionCode)
      });
      return { config: matchedConfig, payload };
    }

    const mgmCode = normalize(url.searchParams.get('ref'));
    const mgmConfigs = enabledConfigs.filter((config) => config.mgm);
    if (mgmCode && mgmConfigs.length) {
      if (mgmConfigs.length > 1) {
        console.warn('[FLIPPO REFERRAL] Hay varios bloques marcados como MGM; se usará el primero.');
      }
      const mgmConfig = mgmConfigs[0];
      const payload = storeReferral(mgmConfig, {
        attributionCode: mgmCode,
        requiresValidation: true
      });
      return { config: mgmConfig, payload };
    }

    if (!matchedConfig) {
      clearStoredReferral();
      return null;
    }
  };

  captureReferral();

  window.FlippoReferral = {
    getActive() {
      const stored = readStoredReferral();
      if (!stored) return null;
      const { config, payload } = stored;
      if (payload.validationStatus === 'pending') return null;

      return {
        id: config.id,
        isBlackweek: config.isBlackweek,
        code: normalize(payload.attributionCode) || config.value,
        offerCode: config.value,
        isMgm: Boolean(config.mgm && payload.attributionCode),
        sellingPlanId: config.sellingPlanId,
        applyPlan: config.applyPlan,
        applyPricing: config.applyPricing,
        discountPercent: config.discountPercent,
        discountText: config.discountText,
        matchPlanQuantity: config.matchPlanQuantity,
        image: config.image,
        configurationValid: Boolean(config.sellingPlanId),
        expiresAt: Number(payload.expiresAt)
      };
    },
    activateMgm(code) {
      const stored = readStoredReferral();
      if (
        !stored ||
        !stored.config.mgm ||
        normalizeCode(stored.payload.attributionCode) !== normalizeCode(code)
      ) {
        return false;
      }

      persistReferral({
        ...stored.payload,
        validationStatus: 'validated'
      });
      notifyReferralChange();
      return true;
    },
    rejectMgm(code) {
      const stored = readStoredReferral();
      if (
        !stored ||
        normalizeCode(stored.payload.attributionCode) !== normalizeCode(code)
      ) {
        return false;
      }

      clearStoredReferral();
      notifyReferralChange();
      return true;
    },
    whenReady() {
      const stored = readStoredReferral();
      if (!stored || stored.payload.validationStatus !== 'pending') {
        return Promise.resolve(this.getActive());
      }

      return new Promise((resolve, reject) => {
        const timeout = window.setTimeout(() => {
          window.removeEventListener('flippo:referral:change', onChange);
          reject(new Error('No hemos podido validar el enlace de referido. Inténtalo de nuevo.'));
        }, 8000);
        const onChange = () => {
          window.clearTimeout(timeout);
          window.removeEventListener('flippo:referral:change', onChange);
          resolve(this.getActive());
        };
        window.addEventListener('flippo:referral:change', onChange);
      });
    },
    clear: clearStoredReferral
  };

  if (window.FlippoMgmReferral && window.FlippoMgmReferral.code) {
    if (window.FlippoMgmReferral.valid === false) {
      window.FlippoReferral.rejectMgm(window.FlippoMgmReferral.code);
    } else if (window.FlippoMgmReferral.valid === true) {
      window.FlippoReferral.activateMgm(window.FlippoMgmReferral.code);
    }
  }

  const applyReferralHeroImage = (container = document) => {
    const referral = window.FlippoReferral.getActive();
    if (!referral || !referral.image || !referral.image.src) return;

    container.querySelectorAll('.qr-hero__card').forEach((card) => {
      const currentMedia = card.querySelector('.qr-hero__media, .qr-hero__placeholder');
      if (!currentMedia || currentMedia.dataset.referralImageApplied === 'true') return;

      let image = currentMedia;
      if (currentMedia.tagName !== 'IMG') {
        image = document.createElement('img');
        image.className = 'qr-hero__media';
        image.loading = 'eager';
        image.sizes = '(min-width: 760px) 660px, calc(100vw - 40px)';
        currentMedia.replaceWith(image);
      }

      image.src = referral.image.src;
      if (referral.image.srcset) {
        image.srcset = referral.image.srcset;
      } else {
        image.removeAttribute('srcset');
      }
      image.alt = referral.image.alt || image.alt || '';
      image.dataset.referralImageApplied = 'true';
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => applyReferralHeroImage(), { once: true });
  } else {
    applyReferralHeroImage();
  }

  document.addEventListener('shopify:section:load', (event) => {
    applyReferralHeroImage(event.target);
  });

  window.addEventListener('flippo:referral:change', () => {
    applyReferralHeroImage();
  });
})();
